<div class="modal-background" bdFxLayoutAlign="center start" (click)="onModalClicked()">
    <div class="projects-modal" [ngClass]="{'force-full-height': !isInitialized }">
        <div bdFxLayoutAlign="space-between center" class="header">
            <div bdFxFlex bdFxLayoutAlign="start center" class="cancel">
                <button (click)="onCancelBtnClicked()" type="button">Abbrechen</button>
            </div>
            <div bdFxFlex bdFxLayoutAlign="center center"
                 class="title">Angebotsvorschau
            </div>
            <div bdFxFlex bdFxLayoutAlign="end center">

            </div>
        </div>
        <div class="divider"></div>
        <div class="body">

            <div class="btn-container clearfix">


                <div class="float-left">
                    <button type="button" class="pr-btn" [ngClass]="{'active':isTabActive(myProjectTabIdEnum.HARDWARE), 'disabled' : !quoteHardwareUrl}"
                            *ngIf="isVisibleInActiveMode(myProjectTabIdEnum.HARDWARE)"
                            (click)="onTabBtnClicked( myProjectTabIdEnum.HARDWARE)"
                            type="button">
                        Angebot Hardware
                    </button>
                    <button type="button" class="pr-btn" [ngClass]="{'active':isTabActive(myProjectTabIdEnum.SUPPLY) , 'disabled' :!quoteSupplyUrl }"
                            *ngIf="isVisibleInActiveMode(myProjectTabIdEnum.SUPPLY)"
                            (click)="onTabBtnClicked( myProjectTabIdEnum.SUPPLY)"
                            type="button">
                        Angebot Verbrauchsmaterial
                    </button>
                </div>
            </div>
            <div class="divider"></div>
            <bd-fa-button [name]="'fas fa-download'"
                         class="download-btn"
            (click)="onDownloadBtnClicked()">
            </bd-fa-button>
            <div class="iframe-container"  [ngStyle] = "{'display': isTabActive(myProjectTabIdEnum.HARDWARE) ? 'block' : 'none'}">
                <iframe width="100%" height="100%" #hardwareIframe class="iframe">
                </iframe>
            </div>
            <div class="iframe-container" [ngStyle] = "{'display': isTabActive(myProjectTabIdEnum.SUPPLY) ? 'block' : 'none'}">
                <iframe width="100%" height="100%" #supplyIframe class="iframe">
                </iframe>
            </div>
        </div>

        <div class="footer">

            <div class="divider"></div>
            <button type="button" (click)="onSubmitBtnClicked()">
                {{getBottomBtnTitle()}}
            </button>

    </div>

    </div>
</div>
